import React from 'react'

function Test() {
    return (
        <div>
            <h1>Hello world</h1>
        </div>
    )
}

export default Test